<template>
  <div
    class="FilterGroup">
    <template
      v-if="!isLoading">
      <h6
        class="FilterGroup_label FilterGroup_label-desktop">
        {{ label }}
        <span
          v-show="thisGroupActiveFilterValues.length"
          class="FilterGroup_ClearBtn"
          @click="handleClearFilterGroup">
          Clear
        </span>
      </h6>

      <BaseInput
        class="FilterGroup_input FilterGroup_input-desktop"
        v-if="searchBar"
        v-model="searchText"
        :placeholder="searchPlaceholder"
        icon="search"
        show-clear-text
      />

      <BaseInput
        class="FilterGroup_input FilterGroup_input-mobile"
        v-if="searchBar"
        v-model="searchText"
        :height="40"
        :placeholder="searchPlaceholder"
        no-border
        icon="search"
        show-clear-text
      />

      <h6
        class="FilterGroup_label FilterGroup_label-mobile">
        {{ label }}
      </h6>
    </template>

    <div
      v-if="!isLoading"
      class="FilterGroup_Filters"
      key="FG-FilterGroup-Filters">
      <p
        v-show="!showingFilters.length"
        class="FilterGroup_noresults">
        No results for: {{ this.searchText }}
      </p>

      <div
        class="FilterGroup_Filter"
        v-for="filter in showingFilters"
        :key="filter.value">
        <BaseCheckbox
          :label="filter.label"
          :value="thisGroupActiveFilterValues.includes(filter.value)"
          @input="handleFilterInput(filter)"
        />
      </div>

      <BaseButton
        v-show="filteredFilters.length > showCount"
        class="FilterGroup_Btn"
        theme="ghost"
        size="small"
        @click="showAll = !showAll">
        {{ computedBtnText }}
      </BaseButton>
    </div>

    <div
      v-if="isLoading"
      key="FG-FilterGroup-Filters-Placeholders">
      <BasePlaceholder
        height="18px"
      />
      <BasePlaceholder
        class="mt-1"
        width="80%"
        height="18px"
      />
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseButton from '@/components/BaseButton.vue';
import BasePlaceholder from '@/components/BasePlaceholder.vue';

export default {
  name: 'FilterGroup',

  components: {
    BaseInput,
    BaseCheckbox,
    BaseButton,
    BasePlaceholder,
  },

  data() {
    return {
      searchText: '',

      showAll: false,
    };
  },

  props: {
    value:             { type: Array,   required: true },
    groupKey:          { type: String,  default: 'CATEGORY' },
    label:             { type: String,  default: 'Category' },
    filters:           { type: Array,   required: true },
    searchBar:         { type: Boolean, default: true },
    searchPlaceholder: { type: String,  default: 'Search' },
    isLoading:         { type: Boolean, default: false },
    showCount:         { type: Number,  default: 5 },
  },

  computed: {
    filteredFilters() {
      if (!this.searchText) return this.filters;
      return this.filters.filter(
        (f) => f.label.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    },

    showingFilters() {
      return !this.showAll
        ? this.filteredFilters.slice(0, this.showCount)
        : this.filteredFilters;
    },

    computedBtnText() {
      return this.showAll ? '– SHOW LESS' : '+ SHOW MORE';
    },

    thisGroupActiveFilterValues() {
      return this.value
        .filter((activeFilter) => activeFilter.groupKey === this.groupKey)
        .map((f) => f.value);
    },
  },

  methods: {
    handleFilterInput(filter) {
      this.$emit('input', this.groupKey, filter);
    },

    handleClearFilterGroup() {
      this.$emit('clear-group', this.groupKey);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.FilterGroup_label {
  position: relative;
  padding-bottom: 10px;
  color: $mute;
  text-transform: uppercase;
  letter-spacing: .5px;
  overflow: hidden;
}

.FilterGroup_ClearBtn {
  float: right;
  color: $light-blue;
  text-transform: capitalize;
  cursor: pointer;
}

.FilterGroup_label-mobile {
  display: none;
  padding-left: 16px;
  padding-bottom: 0;
  min-height: 34px;
  line-height: 32px;
  border-bottom: $border;
  background-color: #F6F6F6;
}

.FilterGroup_input-mobile + .FilterGroup_label-mobile {
  border-top: $border;
}

.FilterGroup_input-desktop {
  margin-bottom: 12px;
}

.FilterGroup_input-mobile {
  display: none;
}

.FilterGroup_noresults {
  padding: 4px 0;
}

.FilterGroup_Filter {
  padding: 4px 0;
}

.FilterGroup_Btn {
  margin-left: -8px;
  margin-top: 4px;
  color: $dark-blue;
}

// Mobile
@media only screen and (max-width: 640px) {
  .FilterGroup {
    display: flex;
    flex-direction: column;
    border-bottom: none !important;
    overflow: hidden;
  }

  .FilterGroup_label-desktop {
    display: none;
  }

  .FilterGroup_input-desktop {
    display: none;
  }

  .FilterGroup_input-mobile {
    display: block;
  }

  .FilterGroup_label-mobile {
    display: block;
  }

  .FilterGroup_Filters {
    flex: 1 1 auto;
    padding: 8px 16px 16px 16px;
    overflow-x: hidden;
  }
}
</style>
